import { UserService } from '@/app/shared/services/user.service'
import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

export const requisitionDraftGuard: CanActivateFn = () =>
  inject(UserService).canCreateRequisitionDraft() || inject(Router).createUrlTree(['/requisitions'])
